import React, { useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { Popover, PopoverContent, PopoverTrigger } from "@finance/components/ui/popover";
import { Calendar } from "@finance/components/ui/calendar";
import { Button } from "@finance/components/ui/button";
import { CalendarBlank } from "@phosphor-icons/react";
import { cn } from "@finance/lib/utils";

// Drop-in replacement for <Input type="date">. onChange receives a native-style
// event { target: { value: "YYYY-MM-DD" } } so existing call sites work unchanged.
export function DateField({ value, onChange, className, placeholder = "Pick a date", disabled, type, ...rest }) {
  const [open, setOpen] = useState(false);
  let selected;
  if (value) {
    const d = typeof value === "string" ? parseISO(value) : value;
    if (isValid(d)) selected = d;
  }
  const emit = (iso) => onChange && onChange({ target: { value: iso } });
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          {...rest}
          className={cn(
            "w-full justify-start gap-2 font-normal lx-num hover:bg-transparent hover:text-inherit",
            "focus-visible:ring-2 focus-visible:ring-[#1B4383]/30 focus-visible:border-[#1B4383]",
            "data-[state=open]:border-[#1B4383] data-[state=open]:ring-2 data-[state=open]:ring-[#1B4383]/30",
            !selected && "text-gray-400",
            className,
          )}
        >
          <CalendarBlank size={15} className="shrink-0 opacity-60" />
          {selected ? format(selected, "dd MMM yyyy") : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => { emit(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
          initialFocus
        />
        {selected && (
          <div className="border-t border-gray-100 p-2 text-right">
            <button type="button" className="text-xs text-gray-500 hover:text-[#1B4383]" onClick={() => { emit(""); setOpen(false); }}>Clear date</button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
